import type { TenantBundle } from "@crosure/tenant-runtime";

/**
 * Runtime configuration for Green Shield Insurance Brokers.
 *
 * IMPORTANT: tenant packages are **environment-agnostic** — the same
 * @crosure/tenant-green-shield-insurance-brokers@x.y.z artefact runs in dev, staging, UAT,
 * and prod. Anything that varies by environment must read from
 * process.env at build time so CI can inject the right values.
 *
 * The lite-studio CI sets:
 *   - NEXT_PUBLIC_STUDIO_API_BASE   (per env)
 *   - NEXT_PUBLIC_CLIENT_API_KEY    (per env)
 *   - NEXT_PUBLIC_ENV               (per env, for feature-flag gating)
 */
export const config: TenantBundle["config"] = {
  studioApiBase: process.env.NEXT_PUBLIC_STUDIO_API_BASE ?? "",
  clientApiKey:  process.env.NEXT_PUBLIC_CLIENT_API_KEY  ?? "",
  forms: {
    defaultFormCode: "",      // fill in once the form is published in Studio
    products: {
      // home: { formCode: "" },
    },
  },
  features: {
    // Tenant-defined feature toggles, e.g.:
    // "show_employer_portal": true,
    // "show_renewal_banner":  process.env.NEXT_PUBLIC_ENV === "prod",
  },
  // Opt out of pieces of the skeleton's shared chrome. Everything defaults
  // to on, so omit this block entirely unless you need one of them off.
  // chrome: {
  //   landingNavbar: false,  // your own pages ship a header (it is position:fixed
  //                          // and would overlay yours, logo and all)
  //   login: false,          // no customer portal behind /dashboard
  //   siteMenu: false,       // no landing.navigation.primary items to list
  // },
};
